"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROWSE_EVENTS = exports.REACH_MAX_LIMIT = exports.CREATE_COLLECTION = exports.REMOVE_EVENT_FROM_COLLECTION = exports.ADD_EVENT_TO_COLLECTION = exports.UPDATE_COLLECTION = exports.UPDATE_COLLECTION_EVENTS = exports.SET_COLLECTIONS = exports.DELETE_COLLECTION = exports.CLEAR_COLLECTIONS = void 0;
var CLEAR_COLLECTIONS = 'collections/clear_collections';
exports.CLEAR_COLLECTIONS = CLEAR_COLLECTIONS;
var DELETE_COLLECTION = 'collections/delete_collection';
exports.DELETE_COLLECTION = DELETE_COLLECTION;
var SET_COLLECTIONS = 'collections/set_collections';
exports.SET_COLLECTIONS = SET_COLLECTIONS;
var UPDATE_COLLECTION_EVENTS = 'collections/update_collection_events';
exports.UPDATE_COLLECTION_EVENTS = UPDATE_COLLECTION_EVENTS;
var UPDATE_COLLECTION = 'collections/update_collection';
exports.UPDATE_COLLECTION = UPDATE_COLLECTION;
var ADD_EVENT_TO_COLLECTION = 'collections/add_event_to_collection';
exports.ADD_EVENT_TO_COLLECTION = ADD_EVENT_TO_COLLECTION;
var REMOVE_EVENT_FROM_COLLECTION = 'collections/remove_event_from_collection';
exports.REMOVE_EVENT_FROM_COLLECTION = REMOVE_EVENT_FROM_COLLECTION;
var CREATE_COLLECTION = 'collections/create_collection';
exports.CREATE_COLLECTION = CREATE_COLLECTION;
var REACH_MAX_LIMIT = 'collections/max_event_limit';
exports.REACH_MAX_LIMIT = REACH_MAX_LIMIT;
var BROWSE_EVENTS = 'collections/browse_events';
exports.BROWSE_EVENTS = BROWSE_EVENTS;
//# sourceMappingURL=actionTypes.js.map